<template>
  <ModalDialog
    ref="dialog"
    title="Assembly Sub-Item"
    icon="fa-clipboard-list-check"
    :showFooter="true"
    :scrollable="true"
    :submitting="submitting"
    closeTitle="Close"
    :showSubmit="false"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />

    <div v-if="!loading">
      <FormGroup v-bind:form="form" :labelColumnSize="3">

        <!-- If glass, display available panels / scanned in panels. Plus current invbin location -->
        <div v-if="isGlassItem || isAssemblyItem">
          <div v-if="!isScanInComplete">
            <ContentTitle>Available Production Items</ContentTitle>
            <StaticDataTable class="static-table-list station-table-med">
              <template v-slot:header>
                <tr>
                  <th>Barcode</th>
                  <th>Current Stage</th>
                  <th>Inventory Bin</th>
                </tr>
              </template>
              <template v-slot:body>
                <tr v-for="panel of matchingProductionItemList" :key="panel.id">
                  <td>{{panel.barcode}}</td>
                  <td>{{panel.currentTaskName}}</td>
                  <td>{{panel.inventoryBin ? panel.inventoryBin.code : '-'}}</td>
                </tr>
              </template>
            </StaticDataTable>
          </div>
        </div>

        <div v-if="hasScannedItems">
          <ContentTitle>Scanned Items</ContentTitle>
          <StaticDataTable class="static-table-list station-table-med">
            <template v-slot:header>
              <tr>
                <th>Type</th>
                <th>Barcode</th>
                <th>Quantity</th>
                <th>Actions</th>
              </tr>
            </template>
            <template v-slot:body>
              <tr v-for="scannedItem of validScannedItemList" :key="scannedItem.id">
                <td>{{formatLookupName(scannedItem.scannedType, AssemblyScannedItemTypeLookup)}}</td>
                <td>{{getBarcodeForScannedItem(scannedItem)}}</td>
                <td>{{scannedItem.scannedQuantity}}</td>
                <td>
                  <ActionDropMenu :tableAction="true" :forceDropdown="true">
                    <DropdownMenuItem @click="revertScannedItemClicked(scannedItem)" icon="fa-undo">Revert Scan</DropdownMenuItem>
                  </ActionDropMenu>
                </td>
              </tr>
            </template>
          </StaticDataTable>
        </div>
        
      </FormGroup>
    </div>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import { InventoryStockTypes, AssemblyScannedItemTypes, AssemblyScannedItemTypeLookup } from '@/store/types'

export default {
  name: 'AssemblySubItemDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    productionStageId: Number,
    productionStationId: Number,
    productionPanel: Object,
    order: Object,
    orderItem: Object,
    matchingProductionItemList: Array,
    productionAssemblyScannedItems: Array
  },
  data() {
    return {
      form: {},
      loading: false,
      loadingError: '',
      submitting: false,
      scannedItemList: []
    }
  },
  created() {
    this.AssemblyScannedItemTypeLookup = AssemblyScannedItemTypeLookup
  },
  mounted() {
  },
  computed: {
    isGlassItem() {
      return this.orderItem.stockType == InventoryStockTypes.glass
    },
    isGeneralItem() {
      return this.orderItem.stockType == InventoryStockTypes.general
    },
    isAssemblyItem() {
      return this.orderItem.stockType == InventoryStockTypes.assembly
    },
    validScannedItemList() {
      return this.scannedItemList.filter(scannedItem => scannedItem.scannedQuantity > 0)
    },
    scannedCount() {
      return this.scannedItemList.reduce((curValue, scannedItem) => {
        return curValue + scannedItem.scannedQuantity
      }, 0)
    },
    requiredCount() {
      if(this.isGeneralItem)
        return this.orderItem.units

      return 1
    },
    hasScannedItems() {
      return this.scannedCount > 0
    },
    isScanInComplete() {
      return this.scannedCount == this.requiredCount
    }
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      this.scannedItemList = _.cloneDeep(this.productionAssemblyScannedItems || [])

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true
      this.form = this.clearFormResponse()
    },
    getBarcodeForScannedItem(scannedItem) {
      if(scannedItem.scannedType == AssemblyScannedItemTypes.general)
        return this.orderItem.stock.barcode

      if(scannedItem.scannedType == AssemblyScannedItemTypes.productionPanel)
        return scannedItem.productionPanel.barcode
    },
    revertScannedItemClicked(scannedItem) {
      this.$apiService.glassProductionStationService.removeScannedItemFromAssembly(this.productionStationId, this.productionPanel.id, { scannedItemId: scannedItem.id })
      .then(response => {
        this.successToast('Scanned Item Reverted')

        // Close dialog
        this.hide()
        this.modalClosed(null)
      })
      .catch(err => {
        let errorInfo = this.processFormResponse(err)
        this.$refs.alertMessage.displayAlert('error', 'Error Removing Item!', errorInfo.errorMessage)
      })
    }
  }
}
</script>